module.exports = __webpack_public_path__ + "img/bg_confetti.6bc61752.png";